module.exports = __webpack_public_path__ + "static/media/4.8080b4d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/4.jpg
// module id = 240
// module chunks = 0